import React from 'react';
import FaqsLayout from './FaqsLayout';

const WebTourFaqsPage = () => {
    return <FaqsLayout simple={false} webTour={true} />;
};

export default WebTourFaqsPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/WebTourFaqsPage.tsx